import { ReactElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { isUserLoggedIn } from 'selectors/auth'

interface ProtectedRouteProps {
  children: ReactElement
  userLoggedIn: boolean
}

interface ReduxState {
  userLoggedIn: boolean
}

const select = (): ReduxState => ({
  userLoggedIn: isUserLoggedIn(),
})

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 * Preserves the intended destination path for redirect after login
 */
const ProtectedRoute = ({
  children,
  userLoggedIn,
}: ProtectedRouteProps): ReactElement => {
  const location = useLocation()

  if (!userLoggedIn) {
    // Redirect to login, but save the current location they were trying to go to
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  return children
}

export default connect(select)(ProtectedRoute)
